import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { ratioOptions } from '@scentregroup/ui/tools/cloudinary/image';
import ResponsiveImage from '../responsive-image';
import ResponsiveVideo from '../responsive-video';
import { jsx as _jsx } from "react/jsx-runtime";

const ResponsiveAsset = _ref => {
  let {
    angleOrigin,
    className,
    desktopImageUrl,
    mobileImageUrl,
    videoUrl,
    mobileRatio,
    desktopRatio,
    numberOfItems,
    alt,
    lazyLoad,
    bgSize,
    onLoad,
    onError,
    dataTestId
  } = _ref;
  const commonProps = {
    className,
    bgSize,
    angleOrigin,
    mobileRatio,
    desktopRatio,
    numberOfItems,
    alt,
    lazyLoad,
    onLoad,
    onError,
    dataTestId
  };

  if (videoUrl) {
    return /*#__PURE__*/_jsx(ResponsiveVideo, _objectSpread(_objectSpread({
      videoUrl: videoUrl
    }, commonProps), {}, {
      "data-test-id": dataTestId,
      "data-id": "responsive-asset_index_ResponsiveAsset_ResponsiveVideo"
    }));
  }

  return /*#__PURE__*/_jsx(ResponsiveImage, _objectSpread(_objectSpread({
    desktopImageUrl: desktopImageUrl,
    mobileImageUrl: mobileImageUrl
  }, commonProps), {}, {
    "data-test-id": dataTestId,
    "data-id": "responsive-asset_index_ResponsiveAsset_ResponsiveImage"
  }));
};

ResponsiveAsset.defaultProps = {
  alt: '',
  lazyLoad: true
};
export default ResponsiveAsset;